<template>
	<div class="c-image-renderer">
		<img src="https://i.redd.it/pgp992et89k61.jpg" />
		<div class="c-image-renderer__divider"></div>
	</div>
</template>

<script>
export default {
	props: ['note'],
};
</script>

<style lang="scss">
.c-image-renderer {
	position: relative;
	overflow-y: hidden;
	max-height: 150px;
	img {
		width: 100%;
		height: auto;
		border-radius: var(--border-radius-sm);
	}

	&__divider {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		border-top: var(--g4) dashed 2px;
		box-shadow: 0 -4.6px 6.4px rgba(0, 0, 0, 0.323),
			0 -9.8px 21.4px rgba(0, 0, 0, 0.477), 0 -30px 96px rgba(0, 0, 0, 0.8);

		&:before {
			content: 'Expand';
			font-size: var(--font-size-xs);
			text-align: center;
			position: absolute;
			bottom: 100%;
			left: 0;
			width: 100%;
		}
	}
}
</style>